import { RootState, ThunkDispatch } from "core-integration/src/store";
import { fetchMyTeam } from "core-integration/src/store/my-team/thunks";
import { ITransferState } from "core-integration/src/store/my-team/types";
import { getTransferState } from "core-integration/src/store/squad/reducers";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import ConfirmTransfersDialog from "./ConfirmTransfersDialog";
import { IListTableProps } from "./CreateSquad";
import SquadBase from "./SquadBase";
import TransfersListTable from "./TransfersListTable";

interface IPropsFromState {
  transfersState: ITransferState | null;
}

interface IPropsFromDispatch {
  fetchMyTeam: () => void;
}

type Props = IPropsFromState & IPropsFromDispatch & WithTranslation;

class Transfers extends React.Component<Props> {
  public componentDidMount() {
    this.props.fetchMyTeam();
  }

  public render() {
    // Don't render until we know what transfers staate we need to render ...
    if (!this.props.transfersState) {
      return null;
    }
    const scoreboard =
      this.props.transfersState.status === "cost" ? "cost" : "basic";
    const { t } = this.props;
    return (
      <SquadBase
        listTable={(listTableProps: IListTableProps) => (
          <TransfersListTable {...listTableProps} />
        )}
        scoreboard={scoreboard}
        submitDialog={(handleHide: () => void, allowNavigation: () => void) => (
          <ConfirmTransfersDialog
            handleHide={handleHide}
            allowNavigation={allowNavigation}
          />
        )}
        title={t("transfers.title", "Transfers")}
      />
    );
  }
}

const mapStateToProps = (state: RootState): IPropsFromState => ({
  transfersState: getTransferState(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  fetchMyTeam: () => dispatch(fetchMyTeam()),
});

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Transfers),
);
